import React from 'react';
import { Edit } from 'react-admin';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';
import { getTransform } from '../rateSettingsTransform';

const LocationPositionRateSettingEdit = () => {
  return (
    <Edit
      mutationMode="pessimistic"
      transform={getTransform(
        ['location_id', 'incremental_margin_percent_1099', 'incremental_margin_percent_w2'],
        'location_position_rate_setting',
      )}
    >
      <PositionRateSettingsForm settingsField="location_position_rate_setting" />
    </Edit>
  );
};

export default LocationPositionRateSettingEdit;
